window.addEventListener('load', () => {
    const element = document.querySelector<HTMLElement>('.woocommerce-product .product-tabs');

    if (!element) return;

    const buttons = element.querySelectorAll<HTMLElement>('ul.product-tab-buttons > li');
    const tabs = element.querySelectorAll<HTMLElement>('.product-tab-list > .product-tab');

    if (!buttons || !tabs) return;

    buttons.forEach((button: HTMLElement, index: number) => {
        const button_for = button.getAttribute('data-tab-for');
        const linked_tab = element.querySelector<HTMLElement>(`.product-tab-list > .product-tab.tab-${button_for}`);

        if (linked_tab) {
            button.addEventListener('click', () => {

                buttons.forEach((btn: HTMLElement) => {
                    btn.classList.remove('active');
                });

                tabs.forEach((tab: HTMLElement) => {
                    tab.classList.remove('active');
                });

                button.classList.add('active');
                linked_tab.classList.add('active');
            });
        }
    });
});